import { render, staticRenderFns } from "./AwardListLink.vue?vue&type=template&id=1ba9b0b7&scoped=true&"
import script from "./AwardListLink.vue?vue&type=script&lang=js&"
export * from "./AwardListLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba9b0b7",
  null
  
)

export default component.exports